import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostCollection_pointsGet_point_number = z.any()
export type TagsPostCollection_pointsGet_point_number = z.infer<typeof tagsPostCollection_pointsGet_point_number>

export const descriptionPostCollection_pointsGet_point_number = z.any()
export type DescriptionPostCollection_pointsGet_point_number = z.infer<typeof descriptionPostCollection_pointsGet_point_number>

export const consumesPostCollection_pointsGet_point_number = z.any()
export type ConsumesPostCollection_pointsGet_point_number = z.infer<typeof consumesPostCollection_pointsGet_point_number>

export const bodyPostCollection_pointsGet_point_number = z.object({ "attachment": z.object({ "encoding": z.string(), "filename": z.string(), "mimetype": z.string().optional(), "file": z.any(), "type": z.string().optional() }) })
export type BodyPostCollection_pointsGet_point_number = z.infer<typeof bodyPostCollection_pointsGet_point_number>

export const responsePostCollection_pointsGet_point_number = z.object({ "payload": z.object({ "identifier": z.string(), "type": z.enum(["electricity","gas","water","coal","heat","other"]).optional(), "meterCode": z.string().optional(), "address": z.string().optional(), "supplier": z.string().optional(), "isSingleRateTariff": z.boolean().optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostCollection_pointsGet_point_number = z.infer<typeof responsePostCollection_pointsGet_point_number>

interface IPostCollection_pointsGet_point_number extends BaseMethodType {
  tags: TagsPostCollection_pointsGet_point_number,
  description: DescriptionPostCollection_pointsGet_point_number,
  consumes: ConsumesPostCollection_pointsGet_point_number,
  body: BodyPostCollection_pointsGet_point_number,
  response: ResponsePostCollection_pointsGet_point_number
}
export const URL = '/collection-points/get-point-number'
export const validation = {
  post: {
    tags: tagsPostCollection_pointsGet_point_number,
    description: descriptionPostCollection_pointsGet_point_number,
    consumes: consumesPostCollection_pointsGet_point_number,
    body: bodyPostCollection_pointsGet_point_number,
    response: responsePostCollection_pointsGet_point_number
  }
}
export interface Collection_pointsGet_point_number extends BaseRouteType {
  post: IPostCollection_pointsGet_point_number
}